import React, { Component, Fragment, useState, useEffect } from 'react';


import { Button, Select, Radio, Typography } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect, useSelector, useDispatch } from 'react-redux';
import { timeArr, dayArr } from './CardInvocation.utils';
import { checkTriggerPharse, getUserInfo } from '../CardActions';
import { triggerInfo } from 'components/skills/cardSkill/report_actions';
import TimeZones from '../../../../../utils/MomenttimeZone';
import './steps.css';

const { Option } = Select;

const { Text, Title } = Typography;
const formItemLayout = {};
const SelectInvoke = (props) => {
  const dispatch = useDispatch();
  const triggerInformation = useSelector(
    (state) => state.report.triggerInformation
  );
  // console.log(triggerInformation);
  const [value, setValue] = useState(
    triggerInformation && triggerInformation.frequency
      ? triggerInformation.frequency
      : 'daily'
  );
  const [error, setError] = useState();
  const [userTimezone, setUserTimezone] = useState(
    triggerInformation && triggerInformation.timeZone
      ? triggerInformation.timeZone
      : 'Asia/Kolkata'
  );
  const [triggerOnWeekends, setTriggerOnWeekends] = useState(
    triggerInformation && triggerInformation.triggerOnWeekends
      ? triggerInformation.triggerOnWeekends
      : false
  );
  const [radioValue, setRadioValue] = useState(
    triggerInformation && triggerInformation.weekends
      ? triggerInformation.weekends
      : false
  );
  const [disabled, setDisabled] = useState(false);
  const [timeOfDay, setTimeOfDay] = useState(
    triggerInformation && triggerInformation.timeOfDay
      ? triggerInformation.timeOfDay
      : '10:00'
  );
  const [data, setData] = useState({});
  const [selectedDay, setSelectedDay] = useState(
    triggerInformation && triggerInformation.selectedDay
      ? triggerInformation.selectedDay
      : 'monday'
  );
  // console.log('triegger info ', triggerInformation, data);
  useEffect(() => {
    if (triggerInformation && Object.keys(triggerInformation).length > 0) {
    } else {
      dispatch(
        triggerInfo({
          selectedDay,
          timeOfDay,
          timeZone: userTimezone,
          frequency: value,
          triggerOnWeekends: radioValue,
        })
      );
    }
  }, [triggerInformation]);
  useEffect(() => {
    if (triggerInformation) {
      dispatch(triggerInfo({ ...triggerInformation, ...data }));
    } else dispatch(triggerInfo(data));
  }, [data]);

  const onChange = (val) => {
    setValue(val);
  };

  const handleChange = (type, value) => {
    if (type === 'frequency') {
      setData({ ...data, frequency: value });
    }
    if (type === 'triggerOnWeekends') {
      setData({ ...data, triggerOnWeekends: value });
      setTriggerOnWeekends(value);
    }
    if (type === 'timeOfDay') {
      setData({ ...data, timeOfDay: value });
      setTimeOfDay(value);
    }
    if (type === 'timeZone') {
      setUserTimezone(value);
      setData({ ...data, timeZone: value });
    }
    if (type === 'selectedDay') {
      setData({ ...data, selectedDay: value });
      setSelectedDay(value);
    }
  };
  const getFormSelections = (value) => {
    return (
      <Fragment>
        {
          value === 'weekly' ? (
            // <div style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div
                style={{
                  display: 'flex',
                  marginBottom: 24,
                  alignItems: 'center',
                }}
              >
                <Text strong style={{ minWidth: '100px' }}>
                  Days
                </Text>

                <Select
                  showSearch
                  style={{ width: '100%' }}
                  autoClearSearchValue
                  mode='multiple'
                  value={selectedDay}
                  onChange={(e) => handleChange('selectedDay', e)}
                  placeholder='Select a day'
                  tokenSeparators={[',']}
                  name='Select a day'
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {dayArr.map((d) => (
                    <Option key={d.value}>{d.text}</Option>
                  ))}
                </Select>
              </div>
            </div>
          ) : (
            ''
          )
          // (
          // </div>
          // <div style={{ marginBottom: 10 }}>
          // <div style={{ display: 'flex', flexDirection: 'column' }}>
          //   <div
          //     style={{
          //       display: 'flex',
          //       marginBottom:24 ,
          //       alignItems: 'center',
          //     }}>
          //     <Text strong style={{ minWidth: '100px' }}>
          //       Send
          //     </Text>

          //     <Select
          //       name='csasad'
          //       style={{ width: '100%' }}
          //       onChange={(e) => {
          //         onChangeRadio(e);
          //         handleChange('triggerOnWeekends', e);
          //       }}
          //       value={triggerOnWeekends}>
          //       <Option value={true}>Weekends</Option>
          //       <Option value={false}>Week Days</Option>
          //     </Select>
          //   </div>
          // </div>
          // </div>
          // )
        }

        {/* <div style={{ marginBottom: 10 }}> */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}
          >
            <Text strong style={{ minWidth: '100px' }}>
              Time
            </Text>
            <Select
              showSearch
              style={{ width: '100%' }}
              autoClearSearchValue
              placeholder='Select Time'
              value={timeOfDay}
              onChange={(e) => {
                handleChange('timeOfDay', e);
              }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              name='SelectTime'
            >
              {timeArr.map((d) => (
                <Option key={d.value}>{d.text}</Option>
              ))}
            </Select>
          </div>
        </div>
        {/* </div> */}
        {/* <div style={{ marginBottom: 10 }}> */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{ display: 'flex', marginBottom: 0, alignItems: 'center' }}
          >
            <Text strong style={{ minWidth: '100px' }}>
              Time zone
            </Text>

            <Select
              showSearch
              style={{ width: '100%' }}
              autoClearSearchValue
              value={userTimezone}
              placeholder='Select TimeZone'
              onChange={(e) => {
                handleChange('timeZone', e);
              }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              name='SelectTimeZone'
            >
              {/* {Timezone.timezones.map((item,index)=>{
return <Option   key={index} value={item.utc[0]}>{item.text}</Option>
})} */}
              {TimeZones.map((item, index) => {
                return (
                  <Option key={index} value={item}>
                    {item}
                  </Option>
                );
              })}
            </Select>
          </div>
        </div>
        {/* </div> */}

        {/* <Form.Item style={{ marginBottom: 2 }} >
               {getFieldDecorator('is_trigger', {
                   rules: [{ required: false, message: 'Cannot be empty!'}],
                   // initialValue: 
               })(<Checkbox onChange={onCheckChange}>Allow skill to be triggerd manually./troopr (trigger phrase)</Checkbox>)}
           </Form.Item> */}

        {/* <div className="form_group_label" >Trigger Word (Used to invoke Skill on Demand ex:myreport)</div> */}
        {/* <Form.Item style={{ marginBottom: 2 }}>
               {getFieldDecorator('triggerPhrase', {
                   rules: [{ required:true, message: 'Cannot be empty!'}],
                   initialValue: props.data.triggerInformation.triggerPhrase
               })(<Input
                 name="trigger_phrase"
             
                 placeholder="trigger phrase"
             
           />)}
           </Form.Item> */}
      </Fragment>
    );
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}
        >
          <Text strong style={{ minWidth: '100px' }}>
            Send
          </Text>
          <Select
            onChange={(e) => {
              onChange(e);
              handleChange('frequency', e);
            }}
            value={value}
            name='daily_weekly'
            style={{ width: '100%' }}
          >
            <Option className='radio_styl' value='daily'>
              Daily
            </Option>
            <Option className='radio_styl' value='weekly'>
              Weekly
            </Option>
          </Select>
        </div>
      </div>
      {getFormSelections(value)}
      {error && <span className='error_message'>{error}</span>}
      <div
        style={{
          marginBottom: 2,
          display: 'flex',
          justifyContent: 'space-between',
          // marginTop: '24px',
        }}
      ></div>
    </>
  );
};

export default withRouter(
  connect(null, { checkTriggerPharse, getUserInfo })(SelectInvoke)
);
